<template>
  <div class="personal_center">
    <div class="warp1200 fix">
      <PersonalCenterMenu :activeIndex="9" />
      <div class="f-fr center_right">
        <div class="member-cancellation-box">
          <!-- STEP 1: 阅读协议 -->
          <div v-if="currentStep === 1" class="step-panel">
            <div class="step-title">{{ memberCancellationDescTitle }}</div>
            <div class="step-content" v-html="memberCancellationDescContent"></div>
            <div class="agree-row" @click="onToggleAgree">
              <span class="check-icon" :class="{ checked: agree }">
                <i v-if="agree"></i>
              </span>
              <span class="agree-text">我已阅读并同意注销或退会告知</span>
            </div>
            <div class="step-actions">
              <button
                class="step-btn is-primary"
                :disabled="!agree"
                @click="onNextStep"
              >
                下一步
              </button>
            </div>
          </div>

          <!-- STEP 2: 选择类型 -->
          <div v-if="currentStep === 2" class="step-panel" style="width: 616px">
            <div class="step-title">请选择您需要的操作</div>
            <div class="radio-group">
              <div class="radio-item" @click="onSelectType('1')">
                <span class="radio-box" :class="{ checked: cancellationType === '1' }">
                  <span v-if="cancellationType === '1'" class="radio-inner"></span>
                </span>
                <span class="radio-label">用户账户注销</span>
              </div>
              <div v-if="isMember" class="radio-item" @click="onSelectType('2')">
                <span class="radio-box" :class="{ checked: cancellationType === '2' }">
                  <span v-if="cancellationType === '2'" class="radio-inner"></span>
                </span>
                <span class="radio-label">退出“皇家游享荟”</span>
              </div>
            </div>
            <div class="step-actions">
              <button class="step-btn is-secondary" @click="onPrevStep">上一步</button>
              <button
                class="step-btn is-primary"
                :disabled="!cancellationType"
                @click="onSubmitStep2"
              >
                下一步
              </button>
            </div>
          </div>

          <!-- STEP 3: 确认 -->
          <div v-if="currentStep === 3" class="step-panel">
            <div class="step-content">
              <p v-if="cancellationType === '1'">请确认，您当前登录的账号申请用户账号注销，一旦您点击确认，我们将按照《用户账户注销告知》进行处理，包括但不限于会员积分清零，会员等级及所有会员权益终止，所有个人信息删除，无法通过原注册手机号登录我们的数字平台等，并且无法撤回。</p>
              <p v-else-if="cancellationType === '2'">请确认，您当前登录的账号申请退出”皇家游享荟”，一旦您点击确认，我们将按照《皇家游享荟会员退会告知》进行处理，包括但不限于会员积分清零，会员等级及所有会员权益终止等，并且无法撤回。</p>
              <p class="phone-info">手机号：{{ currentPhone }}</p>
            </div>
            <div class="step-actions">
              <button class="step-btn is-secondary" @click="onPrevStep">上一步</button>
              <button class="step-btn is-primary" @click="onConfirmCancellation">确认</button>
            </div>
          </div>

          <!-- 验证提示弹窗 -->
          <div v-if="showVerificationPrompt" class="modal-overlay" @click.self="verificationPromptClose">
            <div class="modal-box">
              <div class="modal-content">
                {{ verificationPromptMsg}}
              </div>
              <div class="modal-footer">
                <button class="step-btn is-primary" @click="verificationPromptClose">关闭</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import PersonalCenterMenu from '@/components/User/PersonalCenterMenu'
import Cookies from "js-cookie";
const AGREE_PRIVACY = "AGREE_PRIVACY";
const WORKING_DAYS = "15";  // 处理天数
export default {
  name: 'MemberCancellation',
  components: {
    PersonalCenterMenu
  },
  data () {
    return {
      currentStep: 1,
      agree: false,
      cancellationType: '',
      memberCancellationDescTitle: '',
      memberCancellationDescContent: '',
      showVerificationPrompt: false,
      verificationPromptMsg: '',
      currentPhone: '',
      isMember: false,
      isLogout: false
    }
  },
  async beforeMount () {
    if (!this.userToken) {
      this.$router.push(`/Orchard.Rccl.Users/Login/Login?returnUrl=${encodeURIComponent(window.location.pathname)}`)
      return false
    }
    await this.init()
  },
  computed: {
    userToken() {
      return this.$store.state.user.userToken;
    }
  },
  methods: {
    async init () {
      await this.pageInit();
    },
    async pageInit () {
      await this.getMemberCancellationDesc();
      const res = await api.user.checkIsMemberByToken(this.userToken);
      this.isMember = res.success && res.data;
    },
    async getMemberCancellationDesc () {
      console.log('getMemberCancellationDesc')
      const res = await api.page.getContentByKey({
        key: 'MEMBER_CANCELLATION_DESC'
      })
      if (res.success && res.data) {
        this.memberCancellationDescTitle = res.data.title || '注销协议'
        this.memberCancellationDescContent = res.data.content || ''
      }
    },
    onToggleAgree () {
      this.agree = !this.agree
    },
    onSelectType (value) {
      this.cancellationType = value
    },
    onNextStep () {
      if (this.currentStep === 1 && this.agree) {
        this.currentStep = 2
      }
    },
    onPrevStep () {
      const step = this.currentStep - 1
      this.currentStep = step > 0 ? step : 1
    },
    onSubmitStep2 () {
      if (!this.cancellationType) {
        return
      }
      this.apiVerifyCancellation()
    },
    async apiVerifyCancellation () {
      const userToken = this.$store.state.user.userToken
      const { success, data } = await api.user.memberCancellationCheck({ userName: userToken })
      if (success) {
        if (data.status) {
          this.currentStep = 3
          this.currentPhone = data.phone
        } else {
          this.showVerificationPrompt = true
          this.verificationPromptMsg = data.msg
        }
      } else {
        this.$message.show('error', data || '验证失败')
      }
    },
    async onConfirmCancellation () {
      const userToken = this.$store.state.user.userToken
      const { success, data } = await api.user.memberCancellationSubmit({
        userName: userToken,
        cancellationType: this.cancellationType,
        remark: ''
      })
      if (success) {
        this.isLogout = true;
        this.showVerificationPrompt = true;
        this.verificationPromptMsg = `我们会在${WORKING_DAYS}天内完成数据清理，在此期间您的账户将被冻结并且无法登录，请确认后再提交。`;
      } else {
        this.$message.show('error', data || '提交失败')
      }
    },
    verificationPromptClose () {
      this.showVerificationPrompt = false
      this.verificationPromptMsg = "";
      if(this.isLogout) {
        window.sessionStorage.setItem(AGREE_PRIVACY, "null");
        this.$store.commit("REMOVE_USER_TOKEN");
        localStorage.removeItem('isAcceptPersonalRecommend');
        Cookies.remove("authed", { path: "/" });
        this.$router.replace({ path: "/" });
      }
    }
  }
}
</script>
<style lang="less" scoped>
.personal_center {
  .center_right {
    width: 945px;
    margin-top: 20px;
    background: #fff;
    padding: 20px 0;
  }
}

.member-cancellation-box {
  min-height: 100%;
}

.step-panel {
  border-radius: 16px;
  padding: 30px;
  max-width: 800px;
  margin: 0 auto;
}

.step-title {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin-bottom: 25px;
  text-align: center;
}

.step-content {
  max-height: 400px;
  overflow-y: auto;
  font-size: 14px;
  line-height: 1.8;
  color: #666;
  padding: 20px;
  background: #fafafa;
  border-radius: 8px;
  margin-bottom: 20px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 3px;
  }

  ::v-deep {
    a {
      color: #006ab6;
      text-decoration: underline;
    }

    p {
      margin: 10px 0;
    }
  }
}

.agree-row {
  display: flex;
  align-items: center;
  margin: 20px 0;
  cursor: pointer;
  user-select: none;

  &:hover {
    .check-icon {
      border-color: #fcc300;
    }
  }
}

.check-icon {
  width: 18px;
  height: 18px;
  border: 2px solid #ccc;
  border-radius: 4px;
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;

  &.checked {
    border-color: #fcc300;
    background: #fcc300;

    i {
      width: 10px;
      height: 6px;
      border-left: 2px solid #fff;
      border-bottom: 2px solid #fff;
      transform: rotate(-45deg);
      margin-bottom: 2px;
    }
  }
}

.agree-text {
  font-size: 14px;
  color: #333;
}

.radio-group {
  margin: 20px 0;
}

.radio-item {
  display: flex;
  align-items: center;
  padding: 16px 0;
  cursor: pointer;

  &:hover {
    .radio-box {
      border-color: #fcc300;
    }
  }
}

.radio-box {
  width: 20px;
  height: 20px;
  border: 2px solid #ccc;
  border-radius: 50%;
  margin-right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;

  &.checked {
    border-color: #fcc300;
  }
}

.radio-inner {
  width: 12px;
  height: 12px;
  background: #fcc300;
  border-radius: 50%;
}

.radio-label {
  font-size: 14px;
  color: #333;
}

.step-actions {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 30px;
}

.step-btn {
  height: 44px;
  line-height: 44px;
  border-radius: 22px;
  font-size: 16px;
  text-align: center;
  border: none;
  cursor: pointer;
  transition: all 0.3s;
  width: 300px;

  &.is-primary {
    background: linear-gradient(225deg,rgba(255,219,23,1) 0%,rgba(252,191,0,1) 100%);
    color: #000;

    &:disabled {
      background: linear-gradient(225deg,rgba(255,219,23,.6) 0%,rgba(252,191,0,.6) 100%);
      color: #00000060;
      cursor: not-allowed;
    }

    &:hover:not(:disabled) {
      background: linear-gradient(225deg,rgba(255,219,23,1) 0%,rgba(252,191,0,1) 100%);
    }
  }

  &.is-secondary {
    background: #f0f0f0;
    color: #000;

    &:hover {
      background: #e6e6e6;
    }
  }
}

.confirm-text {
  font-size: 14px;
  color: #333;
  line-height: 1.8;
  margin-bottom: 20px;

  .highlight {
    //color: #f00;
    font-weight: bold;
  }
}

.phone-info {
  font-size: 16px;
  color: #333;
  padding: 20px 0;
  border-top: 1px solid #eee;
}

/* 弹窗样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-box {
  background: #fff;
  border-radius: 16px;
  width: 400px;
  max-width: 90%;
  overflow: hidden;
}

.modal-content {
  padding: 40px 24px;
  font-size: 14px;
  line-height: 1.6;
  min-height: 80px;
  text-align: center;
  color: #333;
  box-shadow: none;
  border: none;
}

.modal-footer {
  padding: 24px 24px 24px;
  display: flex;
  justify-content: center;

  .step-btn {
    width: 60%;
  }
}
</style>
